import CommonContainer from "../../Container/CommonContainer";
import { FaToggleOn, FaToggleOff, FaPen } from "react-icons/fa";
import * as CaseStageService from "../../../Services/Masters/CaseStage/CaseStageService";
import toast from "react-hot-toast";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

const CaseStageComponent = () =>{

    const { register, handleSubmit, formState: { errors }, reset, } = useForm();

    const [caseStageList, setCaseStageList] = useState([]);
    const [selectedCaseStage, setSelectedCaseStage] = useState({});
    const [newCaseStageModal, setNewCaseStageModal] = useState(false);

    const fetchAllCaseStageMasterList = () => {
        CaseStageService.GetCaseStageList()
          .then(({ data }) => {
            if (data.IsSuccess) {
              setCaseStageList(data.Data);
            }
          })
          .catch(() => toast.error("Something went wrong."));
    };

    useEffect(() => {
        fetchAllCaseStageMasterList();
        if (caseStageList.length > 0) {
          //console.log("Updated caseStageList:", caseStageList);
        }
    },[]);

    const onSubmit = (data) => {
      //debugger;
      if (selectedCaseStage?.CaseStageId) {
        data.CaseStageId = selectedCaseStage?.CaseStageId;
        CaseStageService.UpdateCaseStage(data)
          .then(({ data }) => {
            if (data.IsSuccess) {
              fetchAllCaseStageMasterList();
              toast.success("Case Stage updated successfully!");
              handleNewCaseStageModalClose();
            } else {
              toast.error("Something went wrong during update.");
            }
          })
          .catch(() => toast.error("Something went wrong during update."))
          .finally(() => { });
      } else {
        CaseStageService.CreateNewCaseStage(data)
          .then(({ data }) => {
            if (data.IsSuccess) {
              fetchAllCaseStageMasterList();
              toast.success("Case Stage saved successfully!");
              handleNewCaseStageModalClose();
            } else {
              toast.error(data.ResponseMessage);
            }
          })
          .catch(() => toast.error("Something went wrong during creation."))
          .finally(() => { });
      }
    };

    const handleNewCaseStageModalClose = () => {
      reset();
      setSelectedCaseStage([]);
      setNewCaseStageModal(false)
    };

    const handleActivateDeActivateCaseStage = (rec) =>{
      CaseStageService.ActivateDeActivateCaseStage(rec.CaseStageId, !rec.IsActive).then(data => {
        if (data.data.IsSuccess) {
          const message = rec.IsActive ? "Case Stage DeActivated Successfully" : "Case Stage Activated Successfully";
          toast.success(message);
          fetchAllCaseStageMasterList();
        } else {
          toast.error("Somthing went wrong");
        }
        //console.log("data", data)
      }).catch(error => {
        toast.error("Somthing went wrong");
      })
    }

    const handleViewCaseStageDetailById = (CaseStageId) => {
      //debugger;
      const selectedItem = caseStageList.find(item => item.CaseStageId === CaseStageId);
      if(selectedItem != null){
        setSelectedCaseStage(selectedItem);
        setNewCaseStageModal(true);
      }
      else{
        selectedCaseStage({});
      }
    };

    return (
        <>
          {/* <LoadingSpinnerComponent></LoadingSpinnerComponent> */}
          <CommonContainer heading="Case Stage List" buttonText="Add Case Stage" onButtonClick={() => { reset(); setSelectedCaseStage([]); setNewCaseStageModal(true) }}>
    
            <div className="d-flex align-items-center justify-content-between mb-2">
              <div className="d-flex align-items-center gap-2">
              </div>
              {/* <div className="search-box" style={{ position: "relative", width: "320px" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  //ref={selectedSearchUser}
                  style={{
                    paddingRight: "35px",
                    borderRadius: "5px",
                    border: "1px solid #ddd",
                  }}
                />
                <button
                  type="button"
                  className="btn btn-success d-flex align-items-center justify-content-center"
                  style={{
                    padding: '5px',
                    position: "absolute",
                    right: "0px",
                    height: "35px",
                    width: "45px",
                    top: "50%",
                    borderTopLeftRadius: "0",
                    borderBottomLeftRadius: "0",
                    transform: "translateY(-50%)",
                  }}
                  //onClick={fetchUniversalFilterUserData}
                >
                  <FaSearch />
                </button>
    
              </div> */}
            </div>
            <div>
              <div className="table-responsive" >
                <table className="table table-bordered custom-table" >
                  <thead>
                    <tr>
                      <th> Case Stage</th>
                      <th> Active </th>
                      <th> Action </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      caseStageList.length > 0 ? (
                        caseStageList.map((rec, index) => (
                          <tr key={index} >
                            <td>{rec.CaseStage}</td >
                            <td>
                              {rec.IsActive ? <FaToggleOn title="Deactivate CaseStage" onClick={() => handleActivateDeActivateCaseStage(rec)} color="green" size={16} /> : <FaToggleOff onClick={() => handleActivateDeActivateCaseStage(rec)} title="Activate CaseStage" color="red" size={16} />}
                            </td>
                            <td>
                              {/* <FaPenSquare color="green" className="mr-2 cursor-pointer" size={25} onClick={() => handleViewUserDetailById(rec.UserId)} title="Edit User" /> */}
                              <FaPen color="green" className="mr-2 cursor-pointer" onClick={() => handleViewCaseStageDetailById(rec.CaseStageId)} title="Edit CaseStage" />
                              {/* <FaTrash color={"red"} onClick={() => handleUserDelete(rec)} /> */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr><td colSpan="9" className="text-center" > No Data found </td></tr >
                      )}
                  </tbody>
                </table>
              </div>
            </div>

            {newCaseStageModal && (
            <div className="modal-backdrop">
              <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg custom-modal" role="document">
                  <div className="modal-content mb-0 p-0">
                    <div className="modal-header p-2-5">
                      <h5 className="modal-title">{selectedCaseStage?.CaseStage ? "Edit Case Stage" : "New Case Stage"}</h5>
                      <button type="button" className="btn-close" onClick={handleNewCaseStageModalClose}></button>
                    </div>
                    <div className="modal-body p-1">
                      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                        <div className="container mb-0" style={{ fontSize: "13px" }}>

                          <div className="row">

                            <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5">Case Stage</label>
                              <input type="text" className="form-control" placeholder="Enter Case Stage" {...register("CaseStage", { required: "Case Stage is required" })} defaultValue={selectedCaseStage?.CaseStage || ""} />
                              {errors.CaseStage && <p className="text-danger required_error">{errors.CaseStage.message}</p>}
                            </div>
                          </div>
                        </div>

                        <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                          <button type="button" className="btn btn-danger" onClick={handleNewCaseStageModalClose}>Close</button>
                          <button type="submit" className="btn btn-primary">{selectedCaseStage?.CaseStageId ? "Update" : "Save"}</button>
                        </div>

                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
    
          </CommonContainer >
        </>
      );
}

export default CaseStageComponent